import { Pipe, PipeTransform } from '@angular/core';
import { CardMaskKind } from './driver-background-check.view-models';

@Pipe({
  name: 'maskPII'
})
export class MaskPIIPipe implements PipeTransform {
  transform(
    value: string,
    mask: boolean,
    type: CardMaskKind = 'default',
    ssnPreMasked?: boolean,
    alwaysMask?: boolean
  ): string {
    if (!value) {
      return value || '';
    }

    if (type === 'ssn' && ssnPreMasked) {
      return value;
    }

    if (!mask && !alwaysMask) {
      return value;
    }

    const s = String(value);

    switch (type) {
      case 'ssn': {
        const digits = s.replace(/\D/g, '');
        if (digits.length >= 4) {
          return `XXX-XX-${digits.slice(-4)}`;
        }
        return '•'.repeat(s.length);
      }
      case 'license': {
        if (s.length <= 7) {
          return '•'.repeat(s.length);
        }
        return `${s.slice(0, 4)}•••••${s.slice(-3)}`;
      }
      case 'email': {
        const at = s.indexOf('@');
        if (at === -1) {
          return s;
        }
        const local = s.slice(0, at);
        const domain = s.slice(at + 1);
        const prefix = local.slice(0, 2);
        return `${prefix}•••@${domain}`;
      }
      case 'phone': {
        const digits = s.replace(/\D/g, '');
        if (digits.length < 4) {
          return '•'.repeat(s.length);
        }
        return `XXX-XXX-${digits.slice(-4)}`;
      }
      default: {
        if (s.length <= 4) {
          return '•'.repeat(s.length);
        }
        return `${s.slice(0, 2)}•••${s.slice(-2)}`;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/utils/driver-background-check/mask-pii.pipe.ts